import React from 'react';
import Translation from "../../shared/Translation";
import Button from 'shared/Button';
import { useDispatch, useSelector } from 'react-redux';
import { setMemberOnlyTicketsDeleted } from '@/actions/ui';
import { membershipLogoutAndRefresh } from '../../checkout/helpers/membershipLogoutAndRefresh';

const  MemberOnlyTicketsDeleted = () => {
  const dispatch = useDispatch();

  const token = useSelector(state => state.reservation.token);
  const secret = useSelector(state => state.reservation.secret);
  const isRecurring = useSelector(state => state.ui.isRecurring);
  const selectedChildEvent = useSelector(state => state.event?.childEvent?.event);

  const handleOK = async () => {
    dispatch(setMemberOnlyTicketsDeleted(false));
    await dispatch(
      membershipLogoutAndRefresh(token, secret, isRecurring, selectedChildEvent)
    );
  };
  
  const memberOnlyTicketsDeleted = useSelector(state => state.ui.memberOnlyTicketsDeleted);
  if (!memberOnlyTicketsDeleted) {
    return null;
  }

  return (
    <div className="modal-backdrop">
      <div className="modal-dialog" role="dialog" aria-modal="true" aria-labelledby="modal-title">
        <div className="modal-content">
          <h3 id="modal-title" className="modal-title">
            <Translation>{'checkout__some_member_only_tickets_were_removed_from_your_cart'}</Translation>
          </h3>
          <div className="modal-actions">
            <Button
              className="button--primary button--large"
              onClick={handleOK}
            >
              <Translation>{'checkout__ok'}</Translation>
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}


export default MemberOnlyTicketsDeleted;
